
import makerjs from "makerjs";
function B25(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,T = Param[2].param,R = Param[3].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       t = T * 1 * myZoom,
        r = R * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       x0 = t-b, x1 = 0, x2 =t ,x3 =t , y0 = 0, y1 = l,y2 = r, y3 =0,glassH =r, glassW = t,h=r,w=t;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
    var TxtL = "L="+L;
  }  if (r !== 0) {
    var TxtR = "R="+R;
  }  if (t !== 0) {
    var TxtT = "T="+T;
  } 



   var drawAbnormalShapeB25 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLine":new makerjs.paths.Line([x1,y1], [x2,y2]), 
        "RightLine":new makerjs.paths.Line([x2,y2], [x3,y3]), 
        "BottomLine": new makerjs.paths.Line([x3,y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeB25MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x1- markShift, y0], [x1- markShift, y1]),
        "RightShortUpline": new makerjs.paths.Line([x1, y1], [x1- 2 * markShift, y1]),
        "RightShortDnline": new makerjs.paths.Line([x1, y0], [x1- 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeB25MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([x2+ markShift, y3], [x2+ markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x2, y2], [x2+ 2 * markShift, y2]),
        "RightShortDnline": new makerjs.paths.Line([x2, y3], [x2+ 2 * markShift, y3]),
       }
   };
   var drawAbnormalShapeB25MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x3, y3- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB25MarkT = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x1, y2+ markShift], [x2, y2+ markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x1, y2], [x1, y2 + 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB25MarkB, TxtB, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB25MarkT, TxtT, [x1, y2+ 2*markShift], [x2, y2+ 2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB25MarkL, TxtL, [x1-2*markShift, y0], [x1-2*markShift, y1]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB25MarkR, TxtR, [x2+ 3*markShift, y3], [x2+ 3*markShift, y2]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB25: drawAbnormalShapeB25,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB25: drawAbnormalShapeB25,
        drawAbnormalShapeB25MarkL: drawAbnormalShapeB25MarkL,
        drawAbnormalShapeB25MarkT: drawAbnormalShapeB25MarkT,
        drawAbnormalShapeB25MarkR: drawAbnormalShapeB25MarkR,
        drawAbnormalShapeB25MarkB:drawAbnormalShapeB25MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B25;